import { render, staticRenderFns } from "./d-highlight-text.vue?vue&type=template&id=56f3a8ca&scoped=true&"
import script from "./d-highlight-text.vue?vue&type=script&lang=js&"
export * from "./d-highlight-text.vue?vue&type=script&lang=js&"
import style0 from "./d-highlight-text.vue?vue&type=style&index=0&id=56f3a8ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f3a8ca",
  null
  
)

export default component.exports